export const UploadContextNotices = ({ dataType, isMultiState }) => (
  <>
    {isMultiState && (
      <p
        data-testid="state-from-file-notice"
        className="border border-sky-200 bg-sky-50 px-4 py-3 text-sm text-sky-900"
      >
        State will be read from the <strong>State</strong> column in every file row.
      </p>
    )}
    {dataType === "fees" && (
      <p
        data-testid="fee-template-columns-note"
        className="border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-950"
      >
        Fee files use: <strong>State, College, Course, Quota, Tuition Fee, Stipend</strong>.
        Other Fee is not required.
      </p>
    )}
    {dataType === "allotment" && (
      <p
        data-testid="allotment-template-columns-note"
        className="border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-950"
      >
        KEA files can use: <strong>All India Rank, Name of the College Allotted., Course Name,
        Allotted Category, Course_fees</strong>.
      </p>
    )}
  </>
);